import { LitElement, html, css } from 'vendor/lit'
import { NostoHelper } from 'helpers/nosto'
import styles from 'styles/mixins'
import { addToCart, getProductRecommendations } from 'utils/requests'
import { reRenderShopifySections, toggleCart } from 'utils/shopify'
const { visuallyHidden } = styles

class HHMatchingProduct extends LitElement {
  static properties = {
    loading: {
      reflect: true,
    },
    _trapFocus: {
      state: true,
    },
  }

  constructor() {
    super()
    this.productId = this.getAttribute('product-id')
    this.productRecommendationContainer = this.querySelector(
      '.js-matching-product'
    )
    this.selectedRecommendation = ''
    this.loading = false
    this.cartButton =
      this.querySelector('.js-stl-to-cart') ||
      this.querySelector('.js-recommended-to-cart')
    this.isCartPage = this.hasAttribute('is-cart-page')
    if (this.isCartPage) {
      this.nostoPlacementId =
        this.closest('hh-inline-cart').getAttribute('nosto-placement-id') ||
        false
    } else {
      this.nostoPlacementId = this.getAttribute('nosto-placement-id') || false
    }

    this.nostoIndex = 0

    if (!this.isDisabled) {
      this.nostoPlacementId
        ? this.waitForNostoToLoad()
        : this.getMatchingProduct()
    } else {
      this.adjustRenderedSection()
    }

    this.handleVariantChange = this.onVariantChange.bind(this)
  }

  async getProduct(url) {
    const response = await fetch(`${url}.js`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })

    return await response.json()
  }

  async recommendToCart() {
    this.cartButton.classList.add('is-loading')

    let selectedVariant = document.querySelector(
      '.variants-selector .is-selected'
    )

    // Select the first variant if none are selected and only one exists
    if (!selectedVariant && this.variantCount < 2) {
      selectedVariant = document.querySelector(
        '.variants-selector li:first-child'
      )
      selectedVariant?.classList.add('is-selected')
    }

    if (selectedVariant) {
      const variantId = selectedVariant.getAttribute('variant-id')

      let isPreorder, isSale, preorderDateRange
      if (selectedVariant.hasAttribute('is-preorder')) {
        isPreorder = selectedVariant.getAttribute('is-preorder') !== 'false'
      }

      if (selectedVariant.hasAttribute('data-preorder-date-range')) {
        preorderDateRange = selectedVariant.getAttribute('data-preorder-date-range')
      }

      if (selectedVariant.hasAttribute('is-sale')) {
        isSale = selectedVariant.getAttribute('is-sale') !== 'false'
      }

      let properties = {
        properties: {
          ...(isPreorder && {
            'Pre-Order': selectedVariant.getAttribute('is-preorder'),
          }),
          ...(isSale && { Sale: selectedVariant.getAttribute('is-sale') }),
          ...(preorderDateRange && {
            _PreorderRange: preorderDateRange,
          }),
        },
      }

      reRenderShopifySections(
        await addToCart(
          {
            id: variantId,
            ...properties,
          },
          `header,${this.isCartPage ? 'inline-cart' : 'cart-drawer'}`
        )
      )

      toggleCart()

      this.dispatchEvent(
        new CustomEvent('productAdded', {
          bubbles: true,
          composed: true,
          detail: {
            id: 'cart-notification',
          },
        })
      )

      this.nostoPlacementId && this.nostoIndex++

      // await this.getMatchingProduct()
      this.cartButton.classList.add('product-added')
      this.querySelector('.js-matching-product').classList.add('widget-disable')

      setTimeout(() => {
        this.cartButton.classList.remove('product-added')
        this.querySelector('.js-matching-product').classList.remove(
          'widget-disable'
        )
        // this.addButtonListener()
      }, 2000)
    }

    this.cartButton.classList.remove('is-loading')
  }

  addButtonListener() {
    this.removeButtonListener()
    document
      .querySelector('.js-stl-to-cart')
      ?.addEventListener('click', this.recommendToCart.bind(this))
    document
      .querySelector('.js-recommended-to-cart')
      ?.addEventListener('click', this.recommendToCart.bind(this))
  }

  removeButtonListener() {
    document
      .querySelector('.js-stl-to-cart')
      ?.removeEventListener('click', this.recommendToCart.bind(this))
    document
      .querySelector('.js-recommended-to-cart')
      ?.removeEventListener('click', this.recommendToCart.bind(this))
  }

  toggleButtonState(enabled = true) {
    this.button ??= this.querySelector(
      '.js-stl-to-cart, .js-recommended-to-cart'
    )

    const disabled = !enabled
    this.button.toggleAttribute('disabled', disabled)
    if (disabled) {
      this.button.setAttribute(
        'title',
        window.upsellStrings.sizeSelectionRequired
      )
    } else {
      this.button.removeAttribute('title')
    }
  }

  connectedCallback() {
    super.connectedCallback()

    // const currentTemplate = document.documentElement.dataset.template
    // if (currentTemplate === 'product') this.initVariantSync()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    // this.productVariantPicker?.removeEventListener(
    //   'change',
    //   this.handleVariantChange
    // )
  }

  initVariantSync() {
    this.productVariantPicker = document.querySelector('hh-variant-picker')
    this.productVariantPicker.addEventListener(
      'change',
      this.handleVariantChange
    )

    const selectedSizeInput = this.productVariantPicker.querySelector(
      '[data-product-option="Size"] input[checked]'
    )
    if (selectedSizeInput) {
      const selectedSize = selectedSizeInput.value.split('|')[0].trim()
      if (selectedSize) this.selectSize(selectedSize)
    }
  }

  onVariantChange(event) {
    this.variants ??= [...this.querySelectorAll('[variant-id]')]
    const selectedSize = event.target.value.split('|')[0].trim()
    this.selectSize(selectedSize)
  }

  selectSize(size) {
    const matchingVariant = this.variants.find(
      (variant) => variant.dataset.size === size
    )
    matchingVariant?.click()
  }

  waitForNostoToLoad() {
    this.style.display = 'none'
    let limitInterval = 0
    const checkInterval = setInterval(() => {
      if (typeof window.nostojs === 'function') {
        this.getMatchingProduct()
        clearInterval(checkInterval)
      } else if (limitInterval >= 10) {
        this.getMatchingProduct()
        clearInterval(checkInterval)
      }

      limitInterval++
    }, 1000)
  }

  async getMatchingProduct() {
    if (this.nostoPlacementId && window.nostojs) {
      window.nostojs((api) => {
        NostoHelper.viewEvent(api.defaultSession())
          .setPlacements(
            this.nostoPlacementId
              ? [this.nostoPlacementId]
              : api.placements.getPlacements()
          )
          .load()
          .then(async (response) => {
            const { recommendations } = response.campaigns

            let products = {}
            let realSlotIdRendered = ''

            if (this.nostoPlacementId) {
              products = recommendations[this.nostoPlacementId].products
              realSlotIdRendered =
                recommendations[this.nostoPlacementId].result_id
            } else {
              for (const property in recommendations) {
                if (
                  recommendations[property]['title'].includes(
                    'You Might Also Like'
                  )
                ) {
                  products = recommendations[property].products
                  realSlotIdRendered = recommendations[property].result_id
                  break
                }
              }
            }

            if (products.length > 0) {
              if (this.isCartPage) {
                this.closest('hh-inline-cart').setAttribute(
                  'data-nosto-index',
                  parseInt(
                    this.closest('hh-inline-cart').getAttribute(
                      'data-nosto-index'
                    )
                  ) + 1
                )
              } else {
                ++this.nostoIndex
              }

              const product = await this.getProduct(
                products[
                  this.isCartPage
                    ? this.closest('hh-inline-cart').getAttribute(
                        'data-nosto-index'
                      )
                    : this.nostoIndex
                ].url
              )
              this.renderProductRecommendation(realSlotIdRendered, product)
              this.style.display = 'block'
            } else {
              this.style.display = 'none'
            }
          })
      })
      return
    }

    const productRecommendations = await getProductRecommendations({
      product_id: this.productId,
      limit: 1,
      intent: 'related',
    })

    if (productRecommendations.products?.length === 0) return

    this.renderProductRecommendation(
      realSlotIdRendered,
      productRecommendations.products[0]
    )
  }

  renderProductRecommendation(realSlotIdRendered, product) {
    const container = this.querySelector('.js-matching-product')
    container.innerHTML = ''

    let variantSelector = ''
    product.variants.forEach((variant) => {
      variantSelector += `<li variant-id="${variant.id}">${
        variant.title.split('|')[0]
      }</li>`
    })

    container.innerHTML = `
      <div class="matching-product__image"><img class="cover" src="${product.images[0].replace(
        /\.(jpg|png|gif)/,
        '_150x$&'
      )}" alt="" width="120" height="214"></div>
      <div class="matching-product__content">
        <a href='${
          product.url
        }/?nosto=${realSlotIdRendered}' class="matching-product__content--link" aria-hidden="true">
          <div class="matching-product__content--title">${product.title}</div>
          <div class="matching-product__content--price">${Shopify.formatMoney(
            product.price
          )}</div>
        </a>

        <div class="matching-product__content--variants">
          <p>Select Size</p>
          <ul class="variants-selector">
            ${variantSelector}
          </ul>
        </div>
      </div>
    `
    this.adjustRenderedSection()
  }

  adjustRenderedSection() {
    const container = this.querySelector('.js-matching-product')
    this.variants = [...this.querySelectorAll('[variant-id]')]
    this.variantCount = this.variants.length
    if (
      !this.variants.some((variantButton) =>
        variantButton.classList.contains('is-selected')
      )
    ) {
      this.toggleButtonState(false)
    }
    if (!container.classList.contains('action-added')) {
      container.addEventListener('click', (e) => {
        if (
          e.target.getAttribute('variant-id') === null ||
          e.target.classList.contains('is-selected')
        )
          return
        e.preventDefault()
        this.selectedRecommendation = e.target.getAttribute('variant-id')
        this.querySelectorAll('[variant-id]').forEach((variant) => {
          const isSelected =
            e.target.getAttribute('variant-id') ===
            variant.getAttribute('variant-id')

          variant.classList.toggle('is-selected', isSelected)
        })

        this.toggleButtonState(true)
      })
      this.addButtonListener()
      container.classList.add('action-added')
    }

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return
      this.cartButton.style.setProperty(
        '--hh-button-width',
        `${this.cartButton.querySelector('.text').clientWidth}px`
      )
      observer.unobserve(this)
    }

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px',
    }).observe(this.cartButton.querySelector('.text'))
  }

  get isDisabled() {
    return this.getAttribute('disable-recommendation') == 'true'
  }

  render() {
    return html`<slot></slot>`
  }

  static styles = [visuallyHidden, css``]
}

if (!customElements.get('hh-matching-product')) {
  customElements.define('hh-matching-product', HHMatchingProduct)
}
